/* ------------------------------------------ GRYFF ICON PICKER - T 30.08.2016 ----------------------------------------- */
import HELPER from '@/app/utils/HELPER';
import defaultIcons from './icons/defaultIcons';
(function (jQuery) {
  jQuery.gfIconPicker = function (element, options) {
    const defaults = {
      onSuccess: function (icon) {},
    };
    this.settings = {};

    const $element = jQuery(element);
    const _this = this;

    const _paIcons = '[]';

    const _mdIconPicker = '<div id="md-icon-picker"></div>';
    const _content =
      '<div class="md-content"> <div class="md-modal-handle gf_modal-draggable"> <span class="md-title">Choose Icon<span> </div> <div class="search-wrap"> <input type="text" id="gfIconFilter" name="icon-filter" value="" placeholder="Search icon" /> </div> <div class="icon-list"> <div class="icons-panel fa-panel"></div> <div class="icons-panel payments-panel"></div> </div></div>';

    /* Editor */
    const $gfLeftSideBar = jQuery('#gfLeftSideBar');
    const $divTopBar = jQuery('#divTopBar');
    const $divContentHidden = jQuery('#divContentHidden');

    /* Iframe */
    const $gfFrame = jQuery('#gfFrame');
    const $gryffEditor = $gfFrame.contents().find('.gryffeditor').first();
    const $gryffBody = $gfFrame.contents().find('body').first();
    
    const ICON_FONT_AWESOME = 1;
    let versionIcon = 1;

    this.init = function () {
      this.settings = jQuery.extend({}, defaults, options);

      $divContentHidden.find('#md-icon-picker').remove();
      $divContentHidden.append(_mdIconPicker);

      const $activeModal = jQuery('#md-icon-picker');

      const merId = $gfLeftSideBar.find('#md-settings').data('edittingID');
      const $targetElement = $gryffBody.find('#' + merId);
      versionIcon = typeof $targetElement.attr('data-ver') !== 'undefined' ? parseInt($targetElement.attr('data-ver')) : ICON_FONT_AWESOME;

      $activeModal.gfModalNew({
        header: '',
        footer: 'footer',
        background: '#FFFFFF',
        width: 800,
        height: 600,
        left: $gfLeftSideBar.children().innerWidth(),
        top: $divTopBar.innerHeight(),
        loading: versionIcon != ICON_FONT_AWESOME,
        onContent: function ($content) {
          $content.html(_content);
        },
        onCancel: function () {
          $activeModal.data('gfmodalnew').onClose();
          $activeModal.remove();
        },
        onSave: function () {
          const icon = $activeModal.find('.gficon.active .gf_icon-wrap').html();

          _this.settings.onSuccess(icon);

          $activeModal.data('gfmodalnew').onClose();
          $activeModal.remove();
        },
      });
      $activeModal.data('gfmodalnew').onShow();

      _this.initContentIconPicker($activeModal);
    };
    
    this.initContentIconPicker = function ($activeModal) { 
      if (versionIcon === ICON_FONT_AWESOME) {
        _this.renderListIcon($activeModal, defaultIcons, 'fa ');
        _this.applyEvents($activeModal);
      } else {
        HELPER.getlistIcons(function (jsonData) {
          if (jsonData && jsonData.icons && jsonData.icons.length > 0) {
            const listIcons = jsonData['icons'];
            _this.renderListIconSvg($activeModal, listIcons);
          }
          $activeModal.data('gfmodalnew').offLoading(); 
          _this.applyEvents($activeModal);
        })
      }
    },
    
    this.renderListIconSvg = function ($activeModal, listIconSvg) { 
      const $faPanel = $activeModal.find('.fa-panel');
      let icons = '';
      const listIconSvgLength = listIconSvg.length;
      for (var i = 0; i < listIconSvgLength; i++) {
        const itemIcon = listIconSvg[i];
        icons += `<div class="gficon" data-icon="${itemIcon.name}"><div class="gf_icon-wrap">\n  <svg fill="currentColor" height="100%" class="gf_icon" icon-class="${itemIcon.name}" width="100%" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16">\n    <path fill-rule="evenodd" clip-rule="evenodd" d="${itemIcon.data}" fill="currentColor" />\n  </svg>\n</div></div>`;
      }
      $faPanel.html(icons);
    },

    this.renderListIcon = function ($activeModal, listIcon, prefix = "") {
      const $faPanel = $activeModal.find('.fa-panel');
      let icons = '';
      const listIconLength = listIcon.length;
      for (var i = 0; i < listIconLength; i++) {
        const itemIcon = listIcon[i];
        icons += `<div class="gficon" data-icon="${itemIcon}"><div class="gf_icon-wrap"><i class="gf_icon ${prefix}${itemIcon}"></i></div></div>`;
      }
      $faPanel.html(icons);
    }

    this.applyEvents = function ($activeModal) {
      $activeModal.find('.gficon').off().on('click', function () {
        $activeModal.find('.gficon').removeClass('active');
        jQuery(this).addClass('active');
        return false;
      });

      const $iconList = $activeModal.find('.icon-list');
      $iconList.addClass('optiscroll').optiscroll();

      $activeModal.find('#gfIconFilter').off().on('keyup change', function () {
        const search = jQuery(this).val().trim();
        if (search == '') {
          $activeModal.find('.gficon').removeClass('gf-hide');
        } else {
          $activeModal.find('.gficon').addClass('gf-hide');
          $activeModal.find('.gficon').each(function () {
            const icon = jQuery(this).attr('data-icon');
            if (icon.indexOf(search) > -1) {
              jQuery(this).removeClass('gf-hide');
            }
          });
        }
        return false;
      });
    }

    this.init();
  };

  jQuery.fn.gfIconPicker = function (options) {
    return this.each(function () {
      if (undefined == jQuery(this).data('gficonpicker')) {
        const plugin = new jQuery.gfIconPicker(this, options);
        jQuery(this).data('gficonpicker', plugin);
      }
    });
  };
})(jQuery);
